import React from 'react'

// material ui
import Box from '@mui/material/Box'

// components
import LocationOpenDates from 'components/shared/LocationOpenDates'
import Typography from '@mui/material/Typography'

const LocationSelected = ({ location, isMobile }) => {
  const { name, openDate, closeDate } = location

  // use vertical format on mobile
  const display = isMobile ? 'block' : 'inline'
  const margin = isMobile ? 0 : 1

  return (
    <>
      <Box>
        <Typography variant='body1' display={display}>
          {name}
        </Typography>
        <Typography
          color='text.secondary'
          variant='subtitle1'
          display={display}
          ml={margin}
        >
          <LocationOpenDates openDate={openDate} closeDate={closeDate} />
        </Typography>
      </Box>
    </>
  )
}

export default LocationSelected
